import constants from 'app/constants'
import fetchJSONData from 'app/util/fetchJSONData'

/**
 * Get the avatar bases
 *
 * @returns {object} the result data
 */
export default async function getAvatarBases () {
  return await fetchJSONData(
    `${constants.API_URL}/nft_element/allowed_bases?network=${constants.NETWORK}`,
    {
      method: 'GET',
      headers: {
        'company-id': constants.API_ID,
        'Content-Type': 'application/json'
      }
    }
  )
}
